<template >
  <v-container>
    <!-- чарт звезд -->
    <div class="Panel">
      <iframe src=" https://db.oboi.ru/opt-prod/dskflajdgkljgdajfgdewqregfdgfdksgkljgksf" frameborder="0" width="100%" height="1000px"/>
    </div>
 <!-- расстановка -->
    <div class="Panel">
      <iframe src="https://db.oboi.ru/opt-prod/dskflajdgkljgdajfgdewqregfdgfdksgkljgksf/rasstan/" frameborder="0" width="100%" height="1200px"></iframe>
    </div>
<!-- командировки -->
    <div class="Panel">
      <iframe  src="https://docs.google.com/spreadsheets/d/e/2PACX-1vReGou3du3CksQB9AVnV4BVuBWnfz-y90PkbC_oLBIhApOSQPHxdYwY2Jl-PqSX6WqzNxJzC4MF1EmM/pubhtml?widget=true&amp;headers=false&chrome=false#gid=0&t=0.5119495507708353&lang=ru&currency=RUB&period=custom&date_from=01.03.2023&date_to=03.08.2023" frameborder="0" style="display: inline;" width="100%" height="650px"></iframe>
    </div>
 <!-- переадресация -->
    <div class="mt-14" justify="center" align="center">
      <iframe  src="https://docs.google.com/spreadsheets/d/1_bMkLiHxOR9XrU0cgfT0KnaUgLlFOl5Pu6VV1OMQFGQ/pubhtml?gid=81883721&single=true&t=0.3506489617177151&lang=ru&currency=RUB&period=week&t=0.4700741882849626&lang=ru&currency=RUB&period=week&t=0.5821750966803154&lang=ru&currency=RUB&period=week&t=0.9042908916868273&lang=ru&currency=RUB&period=week&t=0.7952461067760161&lang=ru&currency=RUB&period=week&t=0.6800057604748619&lang=ru&currency=RUB&period=week&t=0.7048727608549561&lang=ru&currency=RUB&period=week&t=0.29540026896580796&lang=ru&currency=RUB&period=week&t=0.8411112796683811&lang=ru&currency=RUB&period=week&t=0.03925915230444699&lang=ru&currency=RUB&period=week&t=0.28322347272946025&lang=ru&currency=RUB&period=week&t=0.4499760919446092&lang=ru&currency=RUB&period=week&t=0.05268719195984595&lang=ru&currency=RUB&period=week&t=0.4088100322253445&lang=ru&currency=RUB&period=week&t=0.9473171109952367&lang=ru&currency=RUB&period=week&t=0.3359358265993755&lang=ru&currency=RUB&period=week&t=0.1490615113887357&lang=ru&currency=RUB&period=week&t=0.5587214110671233&lang=ru&currency=RUB&period=week&t=0.7427041040553004&lang=ru&currency=RUB&period=week&t=0.8251684335955725&lang=ru&currency=RUB&period=week&t=0.4761739308096844&lang=ru&currency=RUB&period=week&t=0.22033141279983348&lang=ru&currency=RUB&period=week&t=0.4166818589855874&lang=ru&currency=RUB&period=week&t=0.5251324224963758&lang=ru&currency=RUB&period=week&t=0.3967741339726567&lang=ru&currency=RUB&period=week&t=0.5592956454501157&lang=ru&currency=RUB&period=week&t=0.7547670235421129&lang=ru&currency=RUB&period=week&t=0.1603039763801517&lang=ru&currency=RUB&period=week&t=0.6614365282720063&lang=ru&currency=RUB&period=week&t=0.4678411446532069&lang=ru&currency=RUB&period=week&t=0.9058423945705436&lang=ru&currency=RUB&period=week&t=0.9814793879847319&lang=ru&currency=RUB&period=week&t=0.5355218685168739&lang=ru&currency=RUB&period=week&t=0.7894647938738721&lang=ru&currency=RUB&period=month&t=0.35195907928369197&lang=ru&currency=RUB&period=month&t=0.42297577573319467&lang=ru&currency=RUB&period=month&t=0.4010322902913428&lang=ru&currency=RUB&period=month&t=0.10606582341745951&lang=ru&currency=RUB&period=custom&date_from=01.03.2023&date_to=03.08.2023" frameborder="0" style="display: inline;" width="700px" height="2500px" scrolling="no"></iframe>
    </div>
  </v-container>
</template>

<script>
  export default {
    name: 'ForSales',
    components: {

    },


  data: () => ({}),
    }
</script>


<style scoped>
.Panel {
  margin-top: 70px;
  margin-bottom: 50px;

  width: 100%;
}

</style>
